<template>
  <div class="line-options-setting-dialog">
    <el-collapse v-model="sizeActiveNames">
      <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
    </el-collapse>
    <chart-common-options-setting-1 :options="options" :ids="ids"></chart-common-options-setting-1>
    <el-collapse v-model="collapseActiveNames">
      <el-collapse-item name="8" class="paddingtb8">
        <template slot="title">
          <div class="tabs flex">
            <div :class="tabsActive == 0 ? 'tabs-item active' : 'tabs-item'" @click="changeActiveHandle($event, 0)">
              数据组
            </div>
            <div :class="tabsActive == 1 ? 'tabs-item active' : 'tabs-item'" @click="changeActiveHandle($event, 1)">
              图例
            </div>
          </div>
        </template>
        <div class="setting-item">
          <template v-if="tabsActive == 0">
            <numberSetting :options="options" :ids="ids"></numberSetting>
            <scrollSetting :options="options" :ids="ids"></scrollSetting>
            <div v-for="(item, index) in seriesData">
              <collapsibleItem
                :key="index"
                name="'data'+ index"
                :type="item.name"
                :is-active="collapse[item.name].isActive"
                @collapsibleItemClick="collapsibleItemClickHandle($event, index)"
              >
                <div slot="heading">{{ item.name }}</div>
                <div slot="body" class="">
                  <LineSeriesSetting
                    :options="options"
                    v-if="collapseDataActiveNames.length !== 0 && collapseDataActiveNames.find(it => it == index)"
                    :seriesSettingItem="item"
                    :ids="ids"
                    :index="index"
                    ref="seriesSetting"
                  ></LineSeriesSetting>
                </div>
              </collapsibleItem>
            </div>
          </template>
          <template v-else>
            <legend-setting :options="options" :ids="ids"></legend-setting>
          </template>
        </div>
      </el-collapse-item>
    </el-collapse>
    <chart-common-options-setting :options="options" :ids="ids"></chart-common-options-setting>
  </div>
</template>

<script>
import legendSetting from "toolbarComponents/bigScreen/common/options/legendSetting"
import ChartCommonOptionsSetting from "toolbarComponents/bigScreen/common/chart-common-options-setting"
import ChartCommonOptionsSetting1 from "toolbarComponents/bigScreen/common/chart-common-options-setting-1"
import LineSeriesSetting from "toolbarComponents/bigScreen/common/options/seriesSetting/lineSeriesSetting"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex"
import scrollSetting from "toolbarComponents/bigScreen/common/options/scrollSetting"
import numberSetting from "toolbarComponents/bigScreen/common/options/numberSetting"

import publicData from "toolbarComponents/bigScreen/common/options/publicData"
export default {
  name: "line-options-setting",
  components: {
    ChartCommonOptionsSetting,
    ChartCommonOptionsSetting1,
    LineSeriesSetting,
    controlWidthAndSizeAndZindex,
    legendSetting,
    scrollSetting,
    numberSetting
  },
  mixins: [publicData],
  props: { options: Object },
  data() {
    return {
      this1: this,
      sizeActiveNames: ["1", "2"],
      collapseDataActiveNames: [],
      selectStyle: "样式1",

      borderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          src: require("assets/images/solid-1.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          src: require("assets/images/dashed-1.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          src: require("assets/images/dotted-1.png")
        }
      ],
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ],
      lineType: [
        {
          title: "直线",
          value: false
        },
        {
          title: "曲线",
          value: true
        }
      ],
      tabsActive: 0, //  显示数据组还是图例
      collapse: {} // 用来存放当前数据组和图例设置里面的展开收起状态
      // options: null
    }
  },
  comments: {},
  watch: {
    seriesData: {
      handler(newVal, oldVal) {
        if (JSON.parse(JSON.stringify(newVal)) !== JSON.parse(JSON.stringify(oldVal))) this.init()
      },
      deep: true
    }
  },
  created() {
    this.init()
  },
  mounted() {
    this.seriesData1 = this.options.chartOption.series
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    // 动态数据
    seriesData: {
      get() {
        if (this.options.chartOption.series) {
          return this.options.chartOption.series
        }
      },
      set(newVal) {
        let params = { ...this.options.chartOption }
        params.series = newVal
        this.$changeOptionsEV(params, "chartOption", false)
      }
    }
  },
  methods: {
    init() {
      // this.optionsHandle()
      // 图表类组件兼容以前老数据，没有seriesTempAttributes属性的数据
      if (!this.options.chartOption.seriesTempAttributes) {
        const seriesTempAttributes = {
          // 用于存放数据中的通用配置项
          coordinateType: "rectangular" //直角坐标系
        }
        this.$changeOptionsEV(seriesTempAttributes, "chartOption.seriesTempAttributes", false)
      }
      this.options.chartOption.series.forEach(item => {
        this.collapse[item.name] = {
          isActive: false,
          shape_isActive: false,
          text_isActive: false
        }
      })
    },
    collapseMouseDown($event, val) {
      if (val == "8") {
        return
      }
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    // 修改折线类型
    changeBorderSelection(item, index) {
      this.seriesData1[index] = item
      this.seriesData = this.seriesData1
    },
    // 切换当前tab激活项
    changeActiveHandle(event, flag) {
      event.stopPropagation()
      this.tabsActive = flag
    },
    // 抽屉展开收起方法
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    }
    // optionsHandle: function (isChangeStyle) {
    //   this.getOptions = this.$getOptions(this.ids)
    //   // 切换样式的时候，重新渲染颜色等
    //   if (isChangeStyle && this.$refs.seriesSetting) {
    //     this.$refs.seriesSetting[0].init()
    //   }
    // }
  }
}
</script>

<style scoped>
.inlineMiddle {
  display: inline-block;
  vertical-align: middle;
}

.percent100 {
  width: 100%;
}
.percent68 {
  width: 68%;
}
.height32 {
  height: 32px;
  line-height: 32px;
}
.percent36 {
  width: 36%;
}
.percent38 {
  width: 38%;
}
.percent56 {
  width: 56%;
}
.color-picker-container .color-text {
  line-height: 20px;
  display: inline-block;
  vertical-align: top;
  color: inherit;
  font-size: 12px;
  max-width: 80%;
}
.item-title-box {
  width: calc(100% - 40px);
  justify-content: space-between;
}
.line-options-setting-dialog/deep/ .el-collapse-item__header {
  min-height: 48px;
  height: auto;
}

/* 名称和输入框中间的滑块 */
.center-slider {
  width: calc(74% - 86px);
}
.percent42 {
  width: 42%;
}
.percent58 {
  width: calc(58% - 8px);
}
.percent58_60 {
  width: calc(58% - 60px);
}
</style>
<style>
.number-input-box {
  position: relative;
  display: inline-block;
}
.number-input-box .el-input-number .el-input__inner {
  padding-right: 30px;
  text-align: left;
}
/*.linestyle-select .el-input__inner {*/
/*  background-repeat: no-repeat;*/
/*  background-size: calc(100% - 26px) auto;*/
/*  background-position: left center;*/
/*}*/
/*.linestyle-select.solid .el-input__inner {*/
/*  background-image: url("../../../../assets/images/solid-1.png") !important;*/
/*}*/
/*.linestyle-select.dashed .el-input__inner {*/
/*  background-image: url("../../../../assets/images/dashed-1.png") !important;*/
/*}*/
/*.linestyle-select.dotted .el-input__inner {*/
/*  background-image: url("../../../../assets/images/dotted-1.png") !important;*/
/*}*/
.number-input-box .suffix_text {
  position: absolute;
  top: 0;
  line-height: 32px;
  right: 0;
}
.line-options-setting-dialog .tabs .tabs-item {
  font-weight: 600;
  font-size: 14px;
  line-height: 48px;
  text-align: center;
  color: var(--subTextColor);
  margin-right: 24px;
}
.line-options-setting-dialog .tabs .tabs-item.active {
  color: var(--themeColor);
  border-bottom: 2px solid;
}
</style>
